import { useId } from 'react'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import type { InputProps } from './types'
import './Input.css'

/** Campo de formulario (DESIGN.md §4): etiqueta visible, 52 px, error junto al campo sin mover el layout. */
export function Input({
  label,
  labelNote,
  help,
  error,
  disabledReason,
  leading,
  trailing,
  id,
  className,
  disabled,
  ...rest
}: InputProps) {
  const uid = useId()
  const inputId = id ?? `hp-input-${uid}`
  const noteId = `${inputId}-note`
  const isDisabled = disabled || Boolean(disabledReason)
  const note = error ?? disabledReason ?? help
  return (
    <div className={cx('hp-field', error && 'hp-field--error', isDisabled && 'hp-field--disabled', className)}>
      <label htmlFor={inputId} className="hp-field__label">
        {label}
        {labelNote && <span className="hp-field__label-note"> {labelNote}</span>}
      </label>
      <div className="hp-field__control">
        {leading && <span className="hp-field__leading">{leading}</span>}
        <input
          id={inputId}
          className="hp-field__input"
          aria-invalid={error ? true : undefined}
          aria-describedby={note ? noteId : undefined}
          disabled={isDisabled}
          {...rest}
        />
        {trailing && <span className="hp-field__trailing">{trailing}</span>}
      </div>
      <div id={noteId} className="hp-field__note" aria-live={error ? 'polite' : undefined}>
        {error ? (
          <>
            <Icon name="alert-triangle" size={18} className="hp-field__note-icon" />
            <span>{error}</span>
          </>
        ) : (
          note
        )}
      </div>
    </div>
  )
}
